/* `$` / `$q` / `$qa` are defined at file scope (NOT inside the IIFE) so
   the post-IIFE sections that follow this file — BACK TO TOP, ACTIVE NAV,
   QUICK VIEW, etc. — can use the same shorthand without ReferenceErrors.
   They were previously defined only inside the IIFE on line 3, which
   broke `var qvOverlay=$('qv-overlay')` at line ~575 because that code
   runs in global scope (the main IIFE closes around line 494).
   The `var` declarations are hoisted; the IIFE re-`var`s them anyway,
   which is harmless under strict mode (re-declaration of var in the same
   scope is allowed; the inner scope shadows the outer if anything). */
var $ = function(id){ return document.getElementById(id) };
var $q = function(s){ return document.querySelector(s) };
var $qa = function(s){ return document.querySelectorAll(s) };

(function(){
'use strict';
var $=function(id){return document.getElementById(id)};
function $q(s){return document.querySelector(s)}
function $qa(s){return document.querySelectorAll(s)}

/* ── helpers ── */
function money(c){return'$'+(c/100).toFixed(0)}
function ann(m){var e=$('sr-out');if(!e)return;e.textContent='';requestAnimationFrame(function(){e.textContent=m})}

/* ── cart ──
   `gc()` / `sc()` / `addItem()` (a localStorage `hhs4` fake-cart store from
   the mockup port) were removed. The badge is now refreshed from the real
   Shopify cart via `syncCartBadge()`; the badge writer below is the only
   piece of that legacy block that survives. */
function refreshBadges(n){
  var d=$('cart-dot'),bd=$('bnav-dot');
  if(d){d.textContent=n;d.classList.toggle('on',n>0)}
  if(bd){bd.textContent=n;bd.classList.toggle('on',n>0)}
  var ci=$('cart-ico');if(ci)ci.setAttribute('aria-label','Cart ('+n+' item'+(n!==1?'s':'')+')')
}

/* ── toast ── */
var _tt;
function showToast(m){
  var t=$('toast'),msg=$('toast-msg');
  if(!t)return;if(msg)msg.textContent=m;
  t.classList.add('on');clearTimeout(_tt);
  _tt=setTimeout(function(){t.classList.remove('on')},2800)
}

/* ── featured price ── */
/* PRICES (hardcoded mockup lookup) removed \u2014 Liquid drives the real price now. */
var cSurf = '', cSize = '';
/* `gp()` removed — Liquid is the source of truth for `#feat-price`. */
/* `refreshFeat()` (mockup-port stub that used to overwrite #feat-price /
   #feat-atc-txt with hardcoded values) removed. The Liquid renders the
   initial values; `updateFeatVariantFromPills()` updates them on pill
   change. The line below is a stub kept only so any lingering caller
   doesn't throw ReferenceError. */
function refreshFeat(){ /* removed; kept as a no-op so any lingering caller doesn't ReferenceError */ }
/* The dead-code remnant block (an old `_refreshFeat_dead` function holding
   the original PRICES/gp() overwrite logic for reference) has been deleted.
   `cartQuickAdd` + `updateFeatVariantFromPills` are the live replacement. */

/* size pills — update cSize, the visible label, the .sel highlight, and
   re-resolve the featured ATC button's variant so the next click adds the
   right product. */
$qa('input[name="fs"]').forEach(function(inp){
  inp.addEventListener('change',function(){
    if(!inp.checked)return;
    cSize=inp.value;
    var l=$('sz-lbl');if(l)l.textContent=inp.value;
    inp.closest('.opt-pills').querySelectorAll('.opt-pill').forEach(function(p){p.classList.remove('sel')});
    inp.closest('.opt-pill').classList.add('sel');
    if(typeof updateFeatVariantFromPills === 'function') updateFeatVariantFromPills();
  });
});
/* surface pills — same pattern as size pills above. */
$qa('input[name="ff"]').forEach(function(inp){
  inp.addEventListener('change',function(){
    if(!inp.checked)return;
    cSurf=inp.value;
    var l=$('sf-lbl');if(l)l.textContent=inp.value+' Print';
    inp.closest('.opt-pills').querySelectorAll('.opt-pill').forEach(function(p){p.classList.remove('sel')});
    inp.closest('.opt-pill').classList.add('sel');
    if(typeof updateFeatVariantFromPills === 'function') updateFeatVariantFromPills();
  });
});

/* Initialize `cSize` and `cSurf` from whichever pill is pre-checked by the
   Liquid (the Liquid pre-selects the default-variant's option values, so
   this seeds the JS state to match what the user sees). Without this,
   cSize/cSurf would keep their mockup defaults (`'Framed'`/`'16×20"'`) and
   the variant resolver would miss real products that use different option
   values. */
(function(){
  var sz = document.querySelector('input[name="fs"]:checked');
  var sf = document.querySelector('input[name="ff"]:checked');
  if(sz) cSize = sz.value;
  if(sf) cSurf = sf.value;
})();

/* ── ATC ── */
/* `doATC()` (mockup-port fake-cart add via localStorage `addItem`) removed.
   Real ATC goes through `cartQuickAdd()` below: POST /cart/add.js →
   Craft cart-drawer.renderContents() → syncCartBadge(). */

/* featured ATC — wired to the REAL Shopify cart.
   Previously this fired a hardcoded `doATC('heel-' + cSurf, ..., gp()*100)`
   fake-cart call that just bumped the localStorage counter. Now `.btn-atc`
   goes through the same delegated `.xsell-add, .card-qadd, .btn-atc`
   handler at the bottom of this file → `cartQuickAdd(btn)` → POST to
   `/cart/add.js` → cart-drawer re-render + `syncCartBadge()`. The variant
   the button adds is kept in sync with the Size/Surface pills by
   `updateFeatVariantFromPills()` below.

   No explicit `addEventListener` is needed here — the delegated handler
   already covers `.btn-atc`. */

/* Variant resolver for #feat-atc.
   The ATC button now sits inside Craft's `<product-form>` web element,
   so this resolver no longer dispatches the cart POST itself — it just
   keeps the form's hidden `id` input in sync with the Size + Surface
   pill selection so Craft's `product-form.js` submits the correct
   variant when the user clicks the button. Visible price + label are
   updated for UX feedback. */
function updateFeatVariantFromPills(){
  var btn = $('feat-atc');
  if(!btn) return;
  var scriptId = btn.dataset.variantsScript;
  var dataEl = scriptId ? document.getElementById(scriptId) : null;
  if(!dataEl){
    return;
  }
  var data;
  try{ data = JSON.parse(dataEl.textContent) }catch(e){ return }
  if(!data || !data.variants || !data.variants.length) return;

  // Find the variant matching cSize on size_idx and cSurf on surface_idx.
  var match = null;
  for(var i = 0; i < data.variants.length; i++){
    var v = data.variants[i];
    var sizeMatch    = data.size_idx    < 0 || v.options[data.size_idx]    === cSize;
    var surfaceMatch = data.surface_idx < 0 || v.options[data.surface_idx] === cSurf;
    if(sizeMatch && surfaceMatch){ match = v; break; }
  }
  if(!match){
    for(var j = 0; j < data.variants.length; j++){
      if(data.variants[j].available){ match = data.variants[j]; break; }
    }
  }
  if(!match) match = data.variants[0];

  // Update the hidden `id` input inside the `<product-form>` so Craft
  // submits this variant. Also reflect in `data-variant-id` for any
  // analytics or theme-editor introspection.
  var hidden = $('feat-atc-variant-id');
  if(hidden) hidden.value = match.id;
  btn.dataset.variantId = match.id;
  btn.dataset.title = data.product_title || 'Item';

  if(match.available){
    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('is-soldout');
  } else {
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-soldout');
  }
  var priceText = '$' + (match.price / 100).toFixed(0);
  var priceEl = $('feat-price');
  if(priceEl) priceEl.textContent = priceText;
  var atcTxt = $('feat-atc-txt');
  if(atcTxt) atcTxt.textContent = match.available ? ('Add to Cart — ' + priceText) : 'Sold out';
}
window.updateFeatVariantFromPills = updateFeatVariantFromPills;


/* Sync the cart count badges (#cart-dot in header, #bnav-dot in mobile
   bottom-nav) from the REAL Shopify cart. The RMK header uses these
   custom badge nodes instead of Craft's `#cart-icon-bubble`, so we
   re-read `/cart.js` after each add-to-cart and write the count.

   Triggered by:
   1. Page load (once).
   2. The theme-native `cartUpdate` pub-sub event published by Craft's
      `product-form.js` on every successful add. Subscribing through the
      theme's own `subscribe()` + `PUB_SUB_EVENTS.cartUpdate` API means
      we participate in the canonical cart pipeline instead of hooking a
      duplicate fetch into a custom POST. */
function syncCartBadge(){
  return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json() })
    .then(function(c){ refreshBadges(c.item_count || 0); return c; })
    .catch(function(e){ /* network failure — leave badges as-is */ });
}
window.syncCartBadge = syncCartBadge;

/* Subscribe to the theme-native cart-update event so the RMK badges
   refresh after Craft's `<product-form>` AJAX add. `subscribe()` comes
   from `assets/pubsub.js`, `PUB_SUB_EVENTS` from `assets/constants.js`;
   both are loaded by theme.liquid in regular (non-module) script tags,
   so `subscribe` lives on window but `PUB_SUB_EVENTS` is a global lexical
   binding accessed directly. If the API isn't ready yet we defer until
   DOMContentLoaded. */
(function bindCartBadgeSync(){
  function attach(){
    try{
      if(typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ syncCartBadge(); });
      return true;
    }catch(e){ return false }
  }
  if(!attach()){
    document.addEventListener('DOMContentLoaded', attach, { once: true });
  }
})();

/* Custom `cartQuickAdd` function + its delegated click handler have been
   REMOVED. Add-to-cart for `.btn-atc` (featured product), `.xsell-add`
   (cross-sell cards), and `.card-qadd` (products grid cards) now flows
   exclusively through Craft's native `<product-form>` web component:
     product-form.js → /cart/add.js → cart-notification.renderContents()
                                    + publish(PUB_SUB_EVENTS.cartUpdate)
   No duplicate event handlers, no duplicate POSTs. */

/* Wishlist removed theme-wide. Previously this section defined `gw()`,
   `toggleW()`, `wishScan()`, a delegated click handler for
   `.btn-wish, .card-wish`, and `shopify:section:load` / `shopify:block:select`
   listeners that re-synced the `aria-pressed` state from the
   `hhs4-w` localStorage key. All gone. The `hhs4-w` key is cleared once
   on init below so any phantom saved IDs from previous sessions don't
   linger in users' browser storage. `window.toggleW` is intentionally
   undefined — any leftover inline `onclick="toggleW(this)"` in old
   server-rendered HTML will throw silently in the console, which is
   fine: the feature is gone, the markup that used it should be too.
   If you ever bring wishlist back, do it via Shopify's customer account
   metafields or a dedicated app, not localStorage. */
try{ localStorage.removeItem('hhs4-w') }catch(e){}

/* ── header scroll ── */
var hdr=$('site-hdr');
var annEl=$q('.ann-bar');
if(hdr&&annEl){
  var hdrObs=new IntersectionObserver(function(en){hdr.classList.toggle('scrolled',!en[0].isIntersecting)},{threshold:0});
  hdrObs.observe(annEl);
}

/* ── mobile menu ──
   Single source of truth. The duplicate `bindBurger()` IIFE that used to
   sit lower in this file has been removed — having two listeners on
   #burger-btn caused each click to toggle twice (open → immediately close)
   so the user never saw the drawer. `openM` / `closeM` are kept as globals
   so the Escape-key handler below + the back-to-top scroll handler can
   call them directly. */
var burger=$('burger-btn'),mNav=$('mob-nav');
var mNavFocusables=[];
var mNavLastFocus=null;

function mNavTrap(e){
  if(e.key!=='Tab'||!mNav||!mNav.classList.contains('open'))return;
  if(!mNavFocusables.length)return;
  var first=mNavFocusables[0],last=mNavFocusables[mNavFocusables.length-1];
  if(e.shiftKey && document.activeElement===first){last.focus();e.preventDefault();}
  else if(!e.shiftKey && document.activeElement===last){first.focus();e.preventDefault();}
}

function openM(){
  if(!burger||!mNav)return;
  burger.classList.add('open');
  mNav.classList.add('open');
  mNav.setAttribute('aria-hidden','false');
  burger.setAttribute('aria-expanded','true');
  burger.setAttribute('aria-label','Close menu');
  document.body.style.overflow='hidden';
  /* Position the drawer just below the ACTUAL bottom edge of the sticky
     site-header. At page top the announcement bar + marquee sit above
     the header, pushing it down to ~y=120; the CSS `top: var(--h-hdr)`
     (60px) puts the drawer behind the header (header z=100 vs drawer
     z=99) so the first link is hidden. Reading the header's
     `getBoundingClientRect().bottom` gives us the correct viewport
     offset regardless of scroll position / chrome visibility. */
  var hdr=document.getElementById('site-hdr');
  if(hdr){
    var hdrBottom=Math.max(0,Math.round(hdr.getBoundingClientRect().bottom));
    mNav.style.top=hdrBottom+'px';
    var bd=document.getElementById('mob-backdrop');
    if(bd) bd.style.top=hdrBottom+'px';
  }
  mNavLastFocus=document.activeElement;
  /* focus trap: cache focusables, move focus to first nav link */
  mNavFocusables=Array.from(mNav.querySelectorAll('a[href],button:not([disabled])'));
  if(mNavFocusables[0]) setTimeout(function(){mNavFocusables[0].focus();},220);
  document.addEventListener('keydown',mNavTrap);
}

function closeM(){
  if(!burger||!mNav)return;
  burger.classList.remove('open');
  mNav.classList.remove('open');
  mNav.setAttribute('aria-hidden','true');
  burger.setAttribute('aria-expanded','false');
  burger.setAttribute('aria-label','Open menu');
  document.body.style.overflow='';
  /* Clear the inline `top` set in openM so the CSS default (`var(--h-hdr)`)
     restores. Without this, scrolling between opens would leave a stale
     pixel offset that doesn't match the current header position. */
  mNav.style.top='';
  var bdEl=document.getElementById('mob-backdrop');
  if(bdEl) bdEl.style.top='';
  document.removeEventListener('keydown',mNavTrap);
  /* return focus to the burger for keyboard users */
  if(mNavLastFocus && mNavLastFocus.focus){mNavLastFocus.focus();}
  else if(burger){burger.focus();}
}

function bindMobileMenu(){
  var b=document.getElementById('burger-btn');
  var n=document.getElementById('mob-nav');
  if(!b||!n||b.dataset.mBound==='1')return;
  b.dataset.mBound='1';
  /* Update module-scoped refs so openM/closeM (and the Escape handler)
     keep working after a `shopify:section:load` re-render. */
  burger=b; mNav=n;
  b.addEventListener('click',function(){
    n.classList.contains('open')?closeM():openM();
  });
  /* Close on link click — natural mobile behavior */
  n.querySelectorAll('.mob-nav-links a, .mob-nav-ctas a').forEach(function(a){
    a.addEventListener('click',function(){closeM();});
  });
}
bindMobileMenu();
document.addEventListener('shopify:section:load',function(e){
  if(e.target && e.target.querySelector && e.target.querySelector('#burger-btn')){
    bindMobileMenu();
  }
});

/* ── search ── */
var sTog=$('srch-toggle'),sDr=$('srch-drawer'),sCls=$('srch-cls'),sInp=$('srch-inp'),sRes=$('srch-results');
function openS(){sDr.classList.add('open');sDr.setAttribute('aria-hidden','false');sTog.setAttribute('aria-expanded','true');setTimeout(function(){sInp&&sInp.focus()},150)}
function closeS(){sDr.classList.remove('open');sDr.setAttribute('aria-hidden','true');sTog.setAttribute('aria-expanded','false')}
if(sTog)sTog.addEventListener('click',openS);
if(sCls)sCls.addEventListener('click',closeS);
/* bottom nav search trigger */
var bns=$('bnav-srch');if(bns)bns.addEventListener('click',function(e){e.preventDefault();openS()});

/* Predictive search — wired to Shopify's REAL `/search/suggest.json`
   endpoint (the same JSON API Craft's `<predictive-search>` custom
   element uses internally). Previously this section used a hardcoded
   `DEMO` array of 6 mockup products with `url:'#'` placeholders — clicks
   went nowhere and the results never matched the actual catalog.
   Now: typing 2+ characters debounces a fetch to
   `/search/suggest.json?q=…&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`,
   then renders each result as a real `<a href="...">` link to the
   product/collection page. The DOM layout + inline styles match the
   previous renderer exactly so the visual design is unchanged. */
var sTimer;
function money_simple(c){ try { return '$'+(c/100).toFixed(0) } catch(e){ return '' } }
function escHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c] }) }
function escRe(s){ return String(s).replace(/[.*+?^${}()|[\]\\]/g,'\\$&') }
function highlight(text, query){
  var safe = escHtml(text);
  if(!query) return safe;
  var safeQ = escHtml(query);
  return safe.replace(new RegExp('('+escRe(safeQ)+')','gi'), '<mark style="background:none;color:#9A7E52;font-weight:600">$1</mark>');
}
function renderPredictive(items, q){
  if(!items || !items.length){
    sRes.innerHTML = '<div style="padding:1rem;font-size:.78rem;color:#6B6860">No results for "'+escHtml(q)+'"</div>';
    return;
  }
  // Render result links — hover/focus/active/aria-selected states are all
  // handled by CSS in `hh-studio.css` (`#srch-results a:hover` etc.). No
  // inline `onmouseenter`/`onmouseleave` — that pattern only covered desktop
  // pointer hover and broke keyboard focus + mobile tap states.
  sRes.innerHTML = items.map(function(h){
    var img = (h.featured_image && h.featured_image.url) || h.image || '';
    var sub = h._type === 'product' ? money_simple(h.price) : (h._type === 'collection' ? 'Collection' : '');
    return '<a href="'+escHtml(h.url)+'" style="display:flex;align-items:center;gap:.75rem;padding:.65rem 1rem;color:#1C1C1A;text-decoration:none;border-bottom:1px solid #E0DDD8">'
      + '<div style="width:40px;height:40px;border-radius:4px;overflow:hidden;background:#F7F4EF;flex-shrink:0">'
      + (img ? '<img src="'+escHtml(img)+'" alt="'+escHtml(h.title)+'" style="width:100%;height:100%;object-fit:cover" loading="lazy">' : '')
      + '</div>'
      + '<div style="flex:1;min-width:0"><div style="font-size:.82rem;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+highlight(h.title, q)+'</div>'
      + '<div style="font-size:.67rem;color:#9A968E">'+escHtml(sub)+'</div></div>'
      + '</a>';
  }).join('');
}
function fetchPredictive(q){
  var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  // Build URL with Shopify's documented predictive-search params. `resources[type]`
  // controls which result categories Shopify returns; `options[unavailable_products]=last`
  // mirrors Craft's behavior of showing sold-out products at the bottom of results.
  var url = base + '?q=' + encodeURIComponent(q)
    + '&resources[type]=product,collection'
    + '&resources[limit]=8'
    + '&resources[options][unavailable_products]=last'
    + '&section_id=predictive-search';
  // Use the JSON endpoint (not the HTML section endpoint) so we keep the
  // existing inline-rendered design instead of swapping in Shopify's stock
  // predictive-search HTML — that would change the visual.
  var jsonUrl = base + '.json?q=' + encodeURIComponent(q)
    + '&resources[type]=product,collection'
    + '&resources[limit]=8'
    + '&resources[options][unavailable_products]=last';
  return fetch(jsonUrl, { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json() })
    .then(function(data){
      var r = (data && data.resources && data.resources.results) || {};
      var products = (r.products || []).map(function(p){ p._type='product'; return p });
      var collections = (r.collections || []).map(function(c){ c._type='collection'; return c });
      return products.concat(collections);
    });
}
if(sInp&&sRes){
  sInp.addEventListener('input',function(){
    clearTimeout(sTimer);
    var q = sInp.value.trim();
    if(q.length < 2){ sRes.innerHTML = ''; return; }
    sTimer = setTimeout(function(){
      sRes.setAttribute('aria-busy', 'true');
      fetchPredictive(q)
        .then(function(items){ renderPredictive(items, q); })
        .catch(function(err){
          console.error('[predictive search] failed:', err);
          sRes.innerHTML = '<div style="padding:1rem;font-size:.78rem;color:#6B6860">Search temporarily unavailable. Press Enter to search.</div>';
        })
        .then(function(){ sRes.removeAttribute('aria-busy'); });
    }, 260);
  });
  document.addEventListener('click',function(e){
    if(!sDr || !sDr.classList.contains('open')) return;
    if(sDr.contains(e.target)) return;
    // Use closest() so a click on the SVG glyph inside the search button still counts as the button
    if(e.target && e.target.closest && e.target.closest('#srch-toggle, #bnav-srch')) return;
    closeS();
  });
}

/* ── escape key ── */
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeM();closeS()}});

/* ── scroll reveal ── */
var rm=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
var inEditor=!!(window.Shopify && window.Shopify.designMode);
var io=null;
if(!rm && !inEditor){
  io=new IntersectionObserver(function(ens){
    ens.forEach(function(en){if(en.isIntersecting){en.target.classList.add('vis');io.unobserve(en.target)}});
  },{threshold:.07,rootMargin:'0px 0px -32px 0px'});
}
function revealScan(root){
  var scope=root&&root.querySelectorAll?root:document;
  var els=scope.querySelectorAll('.fu:not(.vis)');
  // In the theme editor, reveal immediately so section re-renders never appear blank.
  // Outside the editor, observe new elements (or reveal directly if reduced-motion is on).
  if(io){els.forEach(function(el){io.observe(el)})}
  else{els.forEach(function(el){el.classList.add('vis')})}
}
revealScan(document);
// Theme editor: re-scan when sections re-render or blocks are selected,
// otherwise the new .fu elements stay at opacity:0 and the section appears blank.
document.addEventListener('shopify:section:load',function(e){revealScan(e.target)});
document.addEventListener('shopify:block:select',function(e){
  revealScan(e.target.closest('.shopify-section')||document);
});

/* ── featured image gallery dots ── */
var IMGS=[
  'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/IMG_2017.jpg?v=1766075339',
  'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/buynow-b00db377-3255-41d5-b5bc-9c675129cbf4.png?v=1766075339'
];
$qa('.fdot-btn').forEach(function(d,i){
  d.addEventListener('click',function(){
    $qa('.fdot-btn').forEach(function(x){x.classList.remove('on')});d.classList.add('on');
    var img=$('feat-main-img');
    if(img){img.style.opacity='0';setTimeout(function(){img.src=IMGS[i]||IMGS[0];img.style.opacity='1';img.style.transition='opacity .15s'},90)}
  });
});

/* signup form is now Shopify-native via `{% form 'customer' %}` —
   no JS handler needed; the page reloads with `form.errors` /
   `form.posted_successfully?` state rendered by Liquid. */

/* ── init ──
   The cart badge is sourced from the REAL Shopify cart (`/cart.js`) via
   `syncCartBadge`, not from the legacy localStorage `hhs4` key. That way
   the badge is correct from first paint, survives across pages, and
   reflects what's actually checkout-able.

   One-time cleanup: nuke any phantom items left in the legacy `hhs4`
   localStorage cart. The fake cart used to accumulate items from the
   placeholder qAdd flow; with cartQuickAdd routing everything through the
   real Shopify cart, the localStorage data is orphan and should not
   linger (it could confuse future debugging). */
try{ localStorage.removeItem('hhs4'); }catch(e){ /* private mode etc. */ }
syncCartBadge();
refreshFeat();
// Resolve the featured ATC button's data-variant-id from the current pill
// state on page load (the Liquid pre-selects the default variant; this
// re-syncs everything in case the merchant has saved variant state in the
// URL or the pills shipped with a different default).
if(typeof updateFeatVariantFromPills === 'function') updateFeatVariantFromPills();

// Re-sync the badge when the tab becomes visible again — catches changes
// the user made in another tab (e.g. checkout completion, cart clears).
document.addEventListener('visibilitychange', function(){
  if(!document.hidden) syncCartBadge();
});
})();


/* ── BACK TO TOP ── */
var btt = document.getElementById('back-top');
if(btt){
  window.addEventListener('scroll', function(){
    btt.classList.toggle('vis', window.scrollY > 600);
  }, {passive:true});
  btt.addEventListener('click', function(){
    window.scrollTo({top:0, behavior:'smooth'});
  });
}

/* ── ACTIVE NAV STATE — highlight current page ──
   Bug history: the previous matcher used `path.indexOf(navPath) === 0`
   which is a loose prefix test. `/collections/all` starts with both
   `/collections/all` AND `/collections`, so on Gallery (linked to
   `/collections/all`) BOTH it and Collections (linked to `/collections`)
   got the active class.

   The fixed matcher below uses an EXACT or `path-segment-prefix` test:
   `path === navPath` OR `path.startsWith(navPath + '/')`. That keeps
   sub-page handling (e.g. `/pages/about/team` activates the About link)
   while never letting `/collections` claim a `/collections/all*` URL.

   Gallery (`/collections/all`) is given a higher-priority "specific
   collection prefix" match path so that when a URL matches both a
   broad nav target (`/collections`) and a narrow one (`/collections/all`),
   only the narrow one wins. */
(function(){
  var path = window.location.pathname;
  var links = Array.from(document.querySelectorAll('.desk-nav a, .mob-nav-links a'));

  function matches(navPath){
    if(!navPath) return false;
    if(navPath === '/') return path === '/';
    if(path === navPath) return true;
    return path.indexOf(navPath + '/') === 0;
  }

  // Build per-link nav paths.
  var entries = links.map(function(a){
    var href = a.getAttribute('href') || '';
    return { el: a, navPath: href.replace(/^https?:\/\/[^/]+/, '') };
  });

  // Find every link whose navPath matches the current URL.
  var matching = entries.filter(function(e){ return matches(e.navPath); });

  // If MORE THAN ONE link matches (e.g. /collections vs /collections/all
  // both match on a /collections/all URL), keep only the MOST SPECIFIC one
  // — the longest navPath. This prevents the double-underline bug while
  // still allowing future nav links with shared prefixes.
  if(matching.length > 1){
    matching.sort(function(a, b){ return b.navPath.length - a.navPath.length; });
    matching = [matching[0]];
  }

  matching.forEach(function(e){ e.el.classList.add('active'); });
})();


/* ══════════════════════════════════════
   QUICK VIEW
══════════════════════════════════════ */
var QV_PRODUCTS = {
  'Counterbalance': {
    collection:'Figures in Color',
    desc:'A figure caught mid-motion — poised between balance and fall. Bold silhouette on a vivid background.',
    img:'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/IMG_2011.jpg?v=1766072085',
    url:'https://heatherhicksstudio.com/products/counterbalance',
    surfaces:['Acrylic','Canvas','Framed'],
    sizes:['8×8"','16×16"','20×20"','24×30"'],
    basePrice:90
  },
  'Neck Crack': {
    collection:'Faces in Grey',
    desc:'Intimate and quietly powerful — a figure tilting their head, rendered in muted tones with expressive line.',
    img:'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/IMG_2148.png?v=1766675525',
    url:'https://heatherhicksstudio.com/products/neck-crack',
    surfaces:['Acrylic','Framed'],
    sizes:['16×16"','20×20"','24×30"'],
    basePrice:200
  },
  'Wind In Pinks': {
    collection:'Wind Series',
    desc:'Movement captured in soft blush and gold. A figure dissolving into wind — loose, gestural, alive.',
    img:'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/Wind_pink.jpg?v=1766675991',
    url:'https://heatherhicksstudio.com/products/wind-in-pinks',
    surfaces:['Acrylic','Canvas'],
    sizes:['8×8"','16×16"','20×20"'],
    basePrice:90
  },
  'Cool Spots': {
    collection:'Abstract',
    desc:'Six circles — cool, saturated, and hypnotic. An abstract study in colour relationships and visual rhythm.',
    img:'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/Cool_spots.jpg?v=1769539781',
    url:'https://heatherhicksstudio.com/products/cool-spots',
    surfaces:['Acrylic','Canvas','Framed'],
    sizes:['8×8"','16×16"','20×20"','24×30"'],
    basePrice:150
  },
  'Heel': {
    collection:'Black & White Figures',
    desc:'Feminine, unapologetic, and poised — Heel captures the human form with bold, minimal confidence.',
    img:'https://cdn.shopify.com/s/files/1/0670/8137/1802/files/IMG_1698_dd166452-9098-470e-afe0-64bfd314a109.jpg?v=1750009288',
    url:'https://heatherhicksstudio.com/products/heel',
    surfaces:['Framed','Acrylic','Canvas'],
    sizes:['16×20"','20×24"','24×30"','30×40"'],
    basePrice:200
  }
};

var qvOverlay=$('qv-overlay'),qvPanel=$('qv-panel'),qvClose=$('qv-close');
var qvCurrentProduct=null,qvCurrentSurface=null,qvCurrentSize=null;

function openQV(productName){
  var p=QV_PRODUCTS[productName];
  if(!p)return;
  qvCurrentProduct=p;
  qvCurrentSurface=p.surfaces[0];
  qvCurrentSize=p.sizes[0];
  // Populate
  var img=$('qv-img');if(img){img.src=p.img;img.alt=productName}
  var coll=$('qv-coll');if(coll)coll.textContent=p.collection;
  var title=$('qv-title');if(title)title.innerHTML='<em>'+productName+'</em>';
  var desc=$('qv-desc');if(desc)desc.textContent=p.desc;
  var link=$('qv-full-link');if(link)link.href=p.url;
  // Options
  var opts=$('qv-opts');
  if(opts){
    opts.innerHTML=
      '<div class="qv-opts">'+
      '<div><div class="qv-opt-hd">Surface <span class="qv-opt-val" id="qv-surf-lbl">'+p.surfaces[0]+'</span></div>'+
      '<div class="qv-pills" role="radiogroup" aria-label="Surface">'+
      p.surfaces.map(function(s,i){return '<button class="qv-pill'+(i===0?' sel':'')+'" data-surf="'+s+'" aria-pressed="'+(i===0?'true':'false')+'">'+s+'</button>'}).join('')+
      '</div></div>'+
      '<div><div class="qv-opt-hd">Size <span class="qv-opt-val" id="qv-size-lbl">'+p.sizes[0]+'</span></div>'+
      '<div class="qv-pills" role="radiogroup" aria-label="Size">'+
      p.sizes.map(function(s,i){return '<button class="qv-pill'+(i===0?' sel':'')+'" data-size="'+s+'" aria-pressed="'+(i===0?'true':'false')+'">'+s+'</button>'}).join('')+
      '</div></div>'+
      '</div>';
    // Bind pill clicks
    opts.querySelectorAll('[data-surf]').forEach(function(btn){
      btn.addEventListener('click',function(){
        opts.querySelectorAll('[data-surf]').forEach(function(b){b.classList.remove('sel');b.setAttribute('aria-pressed','false')});
        btn.classList.add('sel');btn.setAttribute('aria-pressed','true');
        qvCurrentSurface=btn.dataset.surf;
        var lbl=document.getElementById('qv-surf-lbl');if(lbl)lbl.textContent=btn.dataset.surf;
        updateQVPrice();
      });
    });
    opts.querySelectorAll('[data-size]').forEach(function(btn){
      btn.addEventListener('click',function(){
        opts.querySelectorAll('[data-size]').forEach(function(b){b.classList.remove('sel');b.setAttribute('aria-pressed','false')});
        btn.classList.add('sel');btn.setAttribute('aria-pressed','true');
        qvCurrentSize=btn.dataset.size;
        var lbl=document.getElementById('qv-size-lbl');if(lbl)lbl.textContent=btn.dataset.size;
        updateQVPrice();
      });
    });
  }
  updateQVPrice();
  // Open
  qvOverlay.classList.add('open');
  qvOverlay.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  setTimeout(function(){qvPanel&&qvPanel.focus()},100);
  ann('Quick view opened for '+productName);
}
function updateQVPrice(){
  if(!qvCurrentProduct)return;
  var base=qvCurrentProduct.basePrice;
  var sizeIdx=qvCurrentProduct.sizes.indexOf(qvCurrentSize);
  var surfIdx=qvCurrentProduct.surfaces.indexOf(qvCurrentSurface);
  var price=base+(sizeIdx*40)+(surfIdx===0?0:surfIdx===1?-20:20);
  price=Math.max(base,price);
  var pe=$('qv-price');if(pe)pe.textContent=money(price*100);
  var atcBtn=$('qv-atc');
  if(atcBtn)atcBtn.setAttribute('aria-label','Add to cart — '+money(price*100));
}
function closeQV(){
  qvOverlay.classList.remove('open');
  qvOverlay.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
  qvCurrentProduct=null;
}
if(qvClose)qvClose.addEventListener('click',closeQV);
if(qvOverlay)qvOverlay.addEventListener('click',function(e){if(e.target===qvOverlay)closeQV()});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&qvOverlay&&qvOverlay.classList.contains('open'))closeQV()});

// Wire all Quick View buttons
document.addEventListener('click',function(e){
  var btn=e.target.closest('.card-quick');
  if(!btn)return;
  e.preventDefault();e.stopPropagation();
  var card=btn.closest('[aria-label]');
  if(!card)return;
  var label=card.getAttribute('aria-label')||'';
  var productName=label.split(' — ')[0].trim();
  if(QV_PRODUCTS[productName])openQV(productName);
});

// QV ATC: legacy `doATC` dummy-cart handler removed. The QV modal still
// opens and shows product info, but its Add-to-Cart button is no longer
// wired — QV uses a hardcoded JS `QV_PRODUCTS` table (not real Shopify
// products), so it cannot route through `cartQuickAdd` without a
// product-handle → variant-id lookup. Until QV is migrated to real
// products, the ATC button is a visual element only.


/* ══════════════════════════════════════
   FAQ ACCORDION
══════════════════════════════════════ */
document.querySelectorAll('.faq-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var item=btn.closest('.faq-item');
    var isOpen=item.classList.contains('open');
    // Close all
    document.querySelectorAll('.faq-item').forEach(function(i){
      i.classList.remove('open');
      i.querySelector('.faq-q').setAttribute('aria-expanded','false');
    });
    // Open this one if it was closed
    if(!isOpen){
      item.classList.add('open');
      btn.setAttribute('aria-expanded','true');
    }
  });
});


/* OLD: cookie bar JS removed — desktop + mobile
(function(){
  var bar=document.getElementById('cookie-bar');
  if(!bar)return;
  if(!localStorage.getItem('hhs-cookie-consent')){
    setTimeout(function(){bar.classList.add('vis')},1500);
  }
  document.getElementById('cookie-accept').addEventListener('click',function(){
    localStorage.setItem('hhs-cookie-consent','accepted');
    bar.classList.remove('vis');
  });
  document.getElementById('cookie-decline').addEventListener('click',function(){
    localStorage.setItem('hhs-cookie-consent','declined');
    bar.classList.remove('vis');
  });
})();
*/


/* Mobile nav backdrop — sync with mob-nav .open state, click to close */
(function(){
  var mobBackdrop=document.getElementById('mob-backdrop');
  var burger=document.getElementById('burger-btn');
  var mNav=document.getElementById('mob-nav');
  if(!mobBackdrop || !mNav) return;

  function closeMobile(){
    if(burger){ burger.classList.remove('open'); burger.setAttribute('aria-expanded','false'); burger.setAttribute('aria-label','Open menu'); }
    mNav.classList.remove('open');
    mNav.setAttribute('aria-hidden','true');
    mobBackdrop.classList.remove('open');
    document.body.style.overflow='';
  }

  // Mirror mob-nav .open state onto the backdrop
  var mo=new MutationObserver(function(){
    mobBackdrop.classList.toggle('open', mNav.classList.contains('open'));
  });
  mo.observe(mNav, {attributes:true, attributeFilter:['class']});

  // Clicking the backdrop closes the drawer
  mobBackdrop.addEventListener('click', closeMobile);
})();

/* Announcement bar carousel — rotates slides on a merchant-configured interval.
   Reads `data-interval` (ms) from the .ann-bar element. Always loops.
   Idempotent + scoped per .ann-bar + survives Shopify editor section reloads. */
(function(){
  var DEFAULT_MS = 2000;

  function initBar(bar){
    if(!bar || bar.dataset.rotInit === '1') return;
    var slides = bar.querySelectorAll('.ann-slide');
    if(slides.length < 2){
      // Single slide: just make sure it's visible.
      if(slides.length === 1) slides[0].classList.add('ann-active');
      return;
    }
    bar.dataset.rotInit = '1';

    var interval = parseInt(bar.dataset.interval, 10) || DEFAULT_MS;

    // Find currently-active slide (or default to first)
    var current = 0;
    for(var i = 0; i < slides.length; i++){
      if(slides[i].classList.contains('ann-active')){ current = i; break; }
    }
    slides.forEach(function(s,i){
      if(i !== current) s.classList.remove('ann-active');
      else s.classList.add('ann-active');
    });

    // Stash interval id on the element so we can clear on unload
    bar._rotInterval = setInterval(function(){
      // Bail if element was removed from DOM
      if(!document.body.contains(bar)){
        clearInterval(bar._rotInterval);
        return;
      }
      slides[current].classList.remove('ann-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('ann-active');
    }, interval);
  }

  function initAll(root){
    (root || document).querySelectorAll('.ann-bar').forEach(initBar);
  }

  function teardown(root){
    (root || document).querySelectorAll('.ann-bar').forEach(function(bar){
      if(bar._rotInterval){ clearInterval(bar._rotInterval); bar._rotInterval = null; }
      bar.dataset.rotInit = '';
    });
  }

  // Initial run — works whether script loads before or after DOM is parsed
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when a section reloads
  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function(e){
    teardown(e.target);
  });
  // Block-level edits in the editor also swap markup
  document.addEventListener('shopify:block:select', function(e){
    initAll(e.target.closest('.shopify-section') || document);
  });
})();

/* Search drawer + burger menu — idempotent bindings that survive editor section reloads */
(function(){
  function bindSearch(){
    var sTog = document.getElementById('srch-toggle');
    var sDr  = document.getElementById('srch-drawer');
    var sCls = document.getElementById('srch-cls');
    var sInp = document.getElementById('srch-inp');
    if(!sTog || !sDr || sTog.dataset.searchBound === '1') return;
    sTog.dataset.searchBound = '1';

    function open(){
      sDr.classList.add('open');
      sDr.setAttribute('aria-hidden','false');
      sTog.setAttribute('aria-expanded','true');
      setTimeout(function(){ if(sInp) sInp.focus(); }, 150);
    }
    function close(){
      sDr.classList.remove('open');
      sDr.setAttribute('aria-hidden','true');
      sTog.setAttribute('aria-expanded','false');
    }
    sTog.addEventListener('click', open);
    if(sCls) sCls.addEventListener('click', close);

    // Click outside the drawer also closes it
    document.addEventListener('click', function(e){
      if(!sDr.classList.contains('open')) return;
      if(sDr.contains(e.target) || sTog.contains(e.target)) return;
      close();
    });
    // Escape key
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && sDr.classList.contains('open')) close();
    });
    // Bottom-nav search trigger (mobile)
    var bns = document.getElementById('bnav-srch');
    if(bns && bns.dataset.searchBound !== '1'){
      bns.dataset.searchBound = '1';
      bns.addEventListener('click', function(e){ e.preventDefault(); open(); });
    }
  }

  /* `bindBurger` removed — the single source of truth lives at top of
     this file (`bindMobileMenu()`). Having two click listeners on
     #burger-btn caused each tap to toggle twice and the drawer never
     visibly opened. */

  function initAll(){ bindSearch(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
